<section class="blocking-error-state" role="alert" aria-live="assertive">
  <h1>{{ title() }}</h1>
  <p>{{ message() }}</p>
  @if (primaryActionLabel() || secondaryActionLabel()) {
    <div class="blocking-error-actions">
      @if (secondaryActionLabel(); as label) {
        <button mat-button type="button" (click)="secondaryAction.emit()">
          {{ label }}
        </button>
      }
      @if (primaryActionLabel(); as label) {
        <button
          #primaryActionButton
          mat-flat-button
          type="button"
          [disabled]="primaryActionDisabled()"
          (click)="primaryAction.emit()"
        >
          {{ label }}
        </button>
      }
    </div>
  }
</section>
